import { format, parseISO } from 'date-fns';
import cs from 'classnames';
import { ARTICLE_URL } from '@constants';
import { Article, ArticleVariant } from '@repo/types';
import { Link } from 'react-router';
import { ARTICLE_PUBLISHED_DATE_FORMAT } from '../../constants';
import { Image, ImageVariant } from '../../../common/components/Image';
import { ArticleHighlightedCardProps } from './contracts';

export type ArticleHighlightedCardUIProps = Pick<
  ArticleHighlightedCardProps,
  'variant' | 'style' | 'showAuthor' | 'showDate' | 'showImage' | 'showTag' | 'prioritize' | 'imageObjectFit'
> & {
  article: Article;
};

function ArticleHighlightedCardUI({
  article,
  variant,
  style,
  showAuthor,
  showDate,
  showImage,
  showTag,
  imageObjectFit = 'cover',
}: ArticleHighlightedCardUIProps) {
  const { title, imageSrc, author, slug, publishDate } = article;
  const publishedDate = publishDate ? format(parseISO(publishDate), ARTICLE_PUBLISHED_DATE_FORMAT) : '';

  const className = cs('article-highlighted-card', {
    'article-highlighted-card--no-image': !showImage,
    'article-highlighted-card--no-tag': !showTag,
    'article-highlighted-card--no-date': !showDate,
    'article-highlighted-card--default': variant === ArticleVariant.Default,
    'article-highlighted-card--text-side-by-side': variant === ArticleVariant.TextSideBySide,
  });

  return (
    <article style={style} className={className}>
      <Link className="article-highlighted-card__link-wrapper" to={`${ARTICLE_URL}/${slug}`}>
        {imageSrc && showImage && (
          <div className="article-highlighted-card__media-wrapper">
            <Image
              className="article-highlighted-card__thumbnail"
              variant={ImageVariant.Hero}
              src={imageSrc}
              alt={title}
              width={550}
              height={350}
              style={{ objectFit: imageObjectFit }}
            />
            <div className="article-highlighted-card__content">
              {showDate && (
                <time className="article-highlighted-card__date" dateTime={article.publishDate}>
                  {publishedDate}
                </time>
              )}
              <h1 className="article-highlighted-card__title">{title}</h1>
              {author && showAuthor && (
                <p className="article-highlighted-card__author">
                  <span className="article-highlighted-card__author-label">by </span>
                  <span className="article-highlighted-card__author-value">{author}</span>
                </p>
              )}
            </div>
          </div>
        )}
        {(!imageSrc || !showImage) && (
          <div className="article-highlighted-card__content article-highlighted-card__content--no-image">
            {showDate && (
              <time className="article-highlighted-card__date" dateTime={article.publishDate}>
                {publishedDate}
              </time>
            )}
            <h1 className="article-highlighted-card__title">{title}</h1>
            {author && showAuthor && (
              <p className="article-highlighted-card__author">
                <span className="article-highlighted-card__author-label">by </span>
                <span className="article-highlighted-card__author-value">{author}</span>
              </p>
            )}
          </div>
        )}
      </Link>
    </article>
  );
}

export default ArticleHighlightedCardUI;
